import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getQRUsersRequest,
  deleteQRUsersRequest,
  saveQRUsersRequest,
  getQRTablesRequest,
  scanQRTableRequest,
  saveQRTablesRequest,
  createQRTablesRequest,
  deleteQRTablesRequest,
  createQRUserRequest,
  getTouchSaleTablesRequest,
  dispatchSetTableStatusRequest,
  generateQRTXTRequest,
} from "../../services/qrService";

import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getQRUsers() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getQRUsersRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_QR_USERS_SUCCESS,
        users: response[1],
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* deleteQRUsers({ id }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(deleteQRUsersRequest, token, id);

    if (response[0] === 200) {
      yield put({
        type: actions.DELETE_QR_USER_SUCCESS,
        id,
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* saveQRUser(user) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(saveQRUsersRequest, token, user);
    if (response[0] === 200) {
      notification["info"]({
        message: "Успешно запазено",
      });
      yield put({
        type: actions.SAVE_QR_USER_SUCCESS,
        user,
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getQRTables(user) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getQRTablesRequest, token, user);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_QR_TABLES_SUCCESS,
        tables: response[1],
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(getQRTable)",
    });
  }
}

export function* scanQRTable(guid) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(scanQRTableRequest, token, guid);
    if (response[0] === 200) {
      // Update old one
      yield put({
        type: actions.SCAN_QR_TABLE_SUCCESS,
        scannedQRTable: response[1],
        status: 1,
      });
    } else {
      // Attach a new table
      yield put({
        type: actions.SCAN_QR_TABLE_SUCCESS,
        status: 0,
        scannedQRTable: {
          name: "",
          restaurantId: 0,
          identifier: guid.guid,
        },
      });
    }

    if (response[0] === 401) {
      notification["info"]({
        message: "Грешка",
        description: response[1]["detail"],
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(scanQRTable)",
    });
  }
}

export function* saveQRTable(table) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(saveQRTablesRequest, token, table);
    if (response[0] === 200) {
      yield put({
        type: actions.SAVE_QR_TABLE_SUCCESS,
        table,
      });
      notification["info"]({
        message: "Успешно запазване",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(saveQRTable)",
      description: error,
    });
  }
}

export function* createQRTable(table) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(createQRTablesRequest, token, table);
    if (response[0] === 200) {
      yield put({
        type: actions.CREATE_QR_TABLE_SUCCESS,
        table: response[1],
      });
      notification["info"]({
        message: "Успешно създаване",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(createQRTable)",
      description: error,
    });
  }
}

export function* deleteQRTable({ table }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(deleteQRTablesRequest, token, table);
    if (response[0] === 200) {
      yield put({
        type: actions.DELETE_QR_TABLE_SUCCESS,
        table,
      });
      notification["info"]({
        message: "Успешно изтриване",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(createQRTable)",
      description: error,
    });
  }
}

export function* createQRUser(user) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(createQRUserRequest, token, user);
    if (response[0] === 200) {
      yield put({
        type: actions.CREATE_QR_USER_SUCCESS,
        user: response[1],
      });
      notification["info"]({
        message: "Успешно създаване",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(createQRTable)",
      description: error,
    });
  }
}

export function* dispatchSetTableStatus({ tableId, status }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      dispatchSetTableStatusRequest,
      tableId,
      status,
      token
    );
    if (response[0] === 200) {
      //todo no tables
      yield put({
        type: actions.SET_TABLE_STATUS_SUCCESS,
        identifier: tableId,
        status,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(getTouchsaleTables)",
      description: error,
    });
  }
}

export function* getTouchsaleTables() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getTouchSaleTablesRequest, token);
    if (response[0] === 200) {
      //todo no tables
      yield put({
        type: actions.GET_TOUCHSALE_TABLES_SUCCESS,
        touchSaleTables: response[1],
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(getTouchsaleTables)",
      description: error,
    });
  }
}

export function* generateQRTXT({ qrCodesCount }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(generateQRTXTRequest, token, qrCodesCount);
    // yield put({
    //   type: actions.GENERATE_QR_CODES_TXT_SUCCESS,
    // });

    response[1].blob().then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      // the filename you want
      a.download = "qrtables.txt";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });

    if (response[0] === 200) {
      // yield put({
      //   type: actions.GENERATE_QR_CODES_TXT_SUCCESS,
      // });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка(generateQRTXT)",
      description: error,
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_QR_USERS_REQUEST, getQRUsers),
    yield takeEvery(actions.DELETE_QR_USER_REQUEST, deleteQRUsers),
    yield takeEvery(actions.SAVE_QR_USER_REQUEST, saveQRUser),
    yield takeEvery(actions.GET_QR_TABLES_REQUEST, getQRTables),
    yield takeEvery(actions.SCAN_QR_TABLE_REQUEST, scanQRTable),
    yield takeEvery(actions.SAVE_QR_TABLE_REQUEST, saveQRTable),
    yield takeEvery(actions.CREATE_QR_TABLE_REQUEST, createQRTable),
    yield takeEvery(actions.DELETE_QR_TABLE_REQUEST, deleteQRTable),
    yield takeEvery(actions.CREATE_QR_USER_REQUEST, createQRUser),
    yield takeEvery(actions.SET_TABLE_STATUS_REQUEST, dispatchSetTableStatus),
    yield takeEvery(actions.GET_TOUCHSALE_TABLES_REQUEST, getTouchsaleTables),
    yield takeEvery(actions.GENERATE_QR_CODES_TXT_REQUEST, generateQRTXT),
  ]);
}
